
const digest = '9431b6267dba4b8c8ffe4540c5ce8c5bb6b86cc1523dcf5c58477cc2f1712f4d';
const css = `._linkCard_1o8uq_1 {
  display: inline-block;
  max-width: 100%;
  background: var(--theme-primary-background);
  box-sizing: border-box;
  margin: 0.2em;
  &._linkCardFullWidth_1o8uq_7 {
    width: 100%;
    display: block;
  }
  &:hover {
    --LinkCard--text-decoration: underline;
  }
}
._linkCardVertical_1o8uq_15 {
  ._linkCardLayout_1o8uq_16 {
    flex-direction: column;
  }
}
._linkCardAnchor_1o8uq_20 {
  width: 100%;
  text-decoration: none;
  overflow: hidden;
}

._linkCardLayout_1o8uq_16 {
  border: 1px solid var(--theme-primary-border);
  border-radius: var(--Common--border-radius);
  box-sizing: border-box;
  display: flex;
  min-width: 20px;
  width: 100%;
}
._linkCardImage_1o8uq_34 {
  display: flex;
  flex: 1 0;
  border-bottom: 1px solid var(--theme-primary-border);
  min-width: 50px;
}

._linkCardImageElement_1o8uq_41 {
  width: 100%;
  height: 200px !important; /* important is necessary to override inline styles in placeholder SVG. */
  object-fit: cover;
  &._linkCardImageKeepRatio_1o8uq_45 {
    height: auto !important; /* important is necessary to override inline styles in placeholder SVG. */
  }
}

._linkCardContent_1o8uq_50 {
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacer-2);
  box-sizing: border-box;
  padding: var(--spacer-3);
  overflow: hidden;
}

._linkCardTitle_1o8uq_60 {
  font-size: 18px;
  line-height: 1.1;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--theme-primary-text);
}

._linkCardDescription_1o8uq_69 {
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: var(--theme-primary-text);
}

._linkCardUrl_1o8uq_76 {
  margin-top: var(--spacer-1);
  font-size: 11px;
  font-weight: 400;
  line-height: 10px;
  color: var(--theme-link-text);
}
._linkCardUrlText_1o8uq_83 {
  text-decoration: var(--LinkCard--text-decoration);
  margin-right: var(--spacer-1);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"linkCard":"_linkCard_1o8uq_1","linkCardFullWidth":"_linkCardFullWidth_1o8uq_7","linkCardVertical":"_linkCardVertical_1o8uq_15","linkCardLayout":"_linkCardLayout_1o8uq_16","linkCardAnchor":"_linkCardAnchor_1o8uq_20","linkCardImage":"_linkCardImage_1o8uq_34","linkCardImageElement":"_linkCardImageElement_1o8uq_41","linkCardImageKeepRatio":"_linkCardImageKeepRatio_1o8uq_45","linkCardContent":"_linkCardContent_1o8uq_50","linkCardTitle":"_linkCardTitle_1o8uq_60","linkCardDescription":"_linkCardDescription_1o8uq_69","linkCardUrl":"_linkCardUrl_1o8uq_76","linkCardUrlText":"_linkCardUrlText_1o8uq_83"};
export { css, digest };
  